import {
  PageHeader,
  Spin,
  Select,
  Row,
  Col,
  Switch,
  Input,
  Space,
  message,
  Popconfirm,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  cuentaMask,
  InputItem,
  ButtonItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  SwitchItem,
  DatePickerItem,
  DynamicCardForm,
  TabbedDynamicTable,
} from "../../../../Components/Items";
import { PlusOutlined, FilePdfOutlined } from "@ant-design/icons";
import ModalOrdenAgregarInventarioPdf from "../ModalOrdenAgregarInventarioPdf/ModalOrdenAgregarInventarioPdf.js";
import moment from "moment";

const { Option } = Select;

class VerOrdenAgregarInventario extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    todasInsumos: [],
    todasUbicaciones: [],
    objetoInsumos: null,
    todasCuentaContable: null,
    objetoCuentaContable: null,
    modalAgregarCuentaContable: false,
    numOrden: 0,
    estadoOrden: 0,
    modalPdfVisible: false,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentaContable: res.data });
          this.setState({
            objetoCuentaContable: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "agregarInventario/datosOrdenAgregarInventario",
        {
          empresaId: this.props.empresaId,
          ordenId: this.props.location.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.formRef.current.setFieldsValue({
            ...res.data,
            insumos: res.data.insumos.map((value) => ({
              ...value,
              caducidad: value.caducidad ? moment(value.caducidad) : null,
            })),
          });
          const todasInsumos = res.data.insumosCompletos.map((value) => (
            <Option value={value._id} key={value._id}>
              {value.stringBuscar}
            </Option>
          ))
          this.setState({ numOrden: res.data.numero, estadoOrden: res.data.estado, todasInsumos, conLotesYCaducidades: res.data.conLotesYCaducidades });

          if (this.props.moduloWms && res.data.proyectoId) {
            axios
              .post(
                "ubicacionProyecto/selectUbicacionesProyecto",
                { empresaId: this.props.empresaId, proyectoId: res.data.proyectoId, estado: 3 },
                { headers: this.props.headersToken }
              )
              .then((resUbicaciones) => {
                if (resUbicaciones.data.success === 2) {
                  this.setState({ todasUbicaciones: resUbicaciones.data.ubicaciones || [] });
                }
              });
          }
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }

  async onChangeInsumo(value, index) {
    if (this.formRef.current.getFieldValue("contabilizar")) {
      let arrayValue = await this.formRef.current.getFieldValue("insumos");
      const insumo = this.state.todasInsumos.find(
        (valueInsumos) => valueInsumos._id === arrayValue[index].insumoId
      );
      if (!insumo) return;

      arrayValue[index].costo = insumo.costo;

      this.formRef.current.setFieldsValue({ insumos: arrayValue });
    }
  }

  confirmarAgregarInventario() {
    axios
      .post(
        "agregarInventario/confirmarOrdenAgregarInventario",
        {
          ordenId: this.props.location.state.id,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Inventario agregado");
          NotificacionPolizas(res.data.polizasId)
          NotificacionMovimientosInventario(res.data.movimientosIds)
        } else {
          message.error("Sucedio un error y no se pudo agregar");
        }
        this.consultarTodo();
      });
  }

  cancelarOrdenAgregarInventario() {
    axios
      .post(
        "agregarInventario/cancelarOrdenAgregarInventario",
        {
          ordenId: this.props.location.state.id,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Orden cancelada");
        } else {
          message.error("Sucedio un error y no se pudo cancelar");
        }
        this.consultarTodo();
      });
  }

  toggleModalPdf = () => {
    this.setState({ modalPdfVisible: !this.state.modalPdfVisible });
  };

  

  render() {
    const isMobile = window.innerWidth <= 1000;
    const conLotesYCaducidades = this.state.conLotesYCaducidades;

    const insumosColumns = conLotesYCaducidades
      ? [
          { title: 'Insumo', width: '40%' },
          { title: 'Costo', width: '15%' },
          { title: 'Cantidad', width: '15%' },
          ...(this.props.moduloWms ? [{ title: 'Ubicación', width: '10%' }] : []),
          { title: 'Lote', width: '15%' },
          { title: 'Caducidad', width: '15%' },
        ]
      : [
          { title: 'Insumo', width: '50%' },
          { title: 'Costo', width: '25%' },
          { title: 'Cantidad', width: '25%' },
          ...(this.props.moduloWms ? [{ title: 'Ubicación', width: '15%' }] : []),
        ];

    const allTabs = [
      {
        key: 'insumos',
        label: 'Insumos',
        listName: 'insumos',
        columns: insumosColumns,
        renderRow: ({ key, name, restField, arrayKey }) => (
          <React.Fragment key={key}>
            <tr>
              <td className="td-border">
                <FormItem
                  {...restField}
                  name={[name, "insumoId"]}
                  fieldKey={[arrayKey, "insumoId"]}
                  required
                  noStyle
                >
                  <SelectItem
                    sinBorde
                    disabled
                    style={{ width: "100%" }}
                    placeholder="Insumo"
                  >
                    {this.state.todasInsumos}
                  </SelectItem>
                </FormItem>
              </td>
              <td className="td-border">
                <FormItem
                  {...restField}
                  name={[name, "costo"]}
                  fieldKey={[arrayKey, "costo"]}
                  number
                  noStyle
                  required
                  initialValue={0}
                >
                  <InputNumberItem disabled sinBorde />
                </FormItem>
              </td>
              <td className="td-border">
                <FormItem
                  {...restField}
                  name={[name, "cantidad"]}
                  fieldKey={[arrayKey, "cantidad"]}
                  number
                  noStyle
                  required
                  initialValue={undefined}
                >
                  <InputNumberItem disabled sinBorde />
                </FormItem>
              </td>
              {this.props.moduloWms && (
                <td className="td-border">
                  <FormItem noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const ubicacionId = getFieldValue(['insumos', arrayKey, 'ubicacionId']);
                      const ubicacion = this.state.todasUbicaciones.find((u) => u._id.toString() === ubicacionId?.toString());
                      return (
                        <div style={{ textAlign: 'center' }}>
                          {ubicacion?.nombre || '-'}
                        </div>
                      );
                    }}
                  </FormItem>
                </td>
              )}
              {this.state.conLotesYCaducidades && (
                <>
                  <td className="td-border">
                    <FormItem
                      {...restField}
                      name={[name, "lote"]}
                      fieldKey={[arrayKey, "lote"]}
                      noStyle
                      required
                    >
                      <InputItem disabled placeholder="Lote" />
                    </FormItem>
                  </td>
                  <td className="td-border">
                    <FormItem
                      {...restField}
                      name={[name, "caducidad"]}
                      fieldKey={[arrayKey, "caducidad"]}
                      noStyle
                    >
                      <DatePickerItem disabled placeholder="Caducidad" style={{ width: '100%' }} />
                    </FormItem>
                  </td>
                </>
              )}
            </tr>
          </React.Fragment>
        ),
      },
    ];

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={"Ver Orden - Agregar Inventario : " + this.state.numOrden}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="verOrdenAgregarInventario"
              layout
              bottom={
              <div className="general-form-action-buttons">
                  <Space>
                    <ButtonItem 
                      icon={<FilePdfOutlined />} 
                      onClick={this.toggleModalPdf}
                      lilaB
                      hotkey="shift+v"
                    >
                      Ver PDF
                    </ButtonItem>
                    {this.state.estadoOrden === 1 && (
                      <Popconfirm
                        title={
                          "Seguro que quieres confirmar esta orden de agregar inventario"
                        }
                        onConfirm={() => this.confirmarAgregarInventario()}
                        okText="Si"
                        cancelText="No"
                      >
                        <ButtonItem verdeB hotkey="shift+a" type="primary">Confirmar</ButtonItem>
                      </Popconfirm>
                    )}
                    {this.state.estadoOrden === 1 && (
                      <Popconfirm
                        title={
                          "Seguro que quieres cancelar esta orden de agregar inventario"
                        }
                        onConfirm={() => this.cancelarOrdenAgregarInventario()}
                        okText="Si"
                        cancelText="No"
                      >
                        <ButtonItem hotkey="shift+c" type="primary" rojoB>
                          Cancelar
                        </ButtonItem>
                      </Popconfirm>
                    )}
                    <ButtonItem hotkey="shift+r" cyanB onClick={this.atras.bind(this)}>
                      Regresar
                    </ButtonItem>
                  </Space>
                </div>
              }
            >
              <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
              <Col xs={24} xl={24}>
                <DynamicCardForm
                  title="DATOS GENERALES"
                  style={{ margin: 0, height: '100%' }}
                >
                  <Row>
                    <Col span={12}>
                      <FormItem label="Proyecto" name="proyectoId" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                        <SelectItem disabled noDisabledBackground placeholder="Proyecto">
                          {this.state.objetoProyectos}
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem name="referencia" label="Referencia" margin pattern labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                        <InputItem disabled placeholder="Referencia" />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <FormItem
                        label="Contabilizar"
                        name="contabilizar"
                        margin
                        initialValue={false}
                        valuePropName="checked"
                        labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}
                      >
                        <Switch disabled />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                          const contabilizar = getFieldValue("contabilizar");
                          if (contabilizar) {
                            return (
                              <FormItem label="Cuenta Abono" margin labelCol={{ span: 6 }} wrapperCol={{ span: 15 }}>
                                <Input.Group compact>
                                  <FormItem name="cuentaAbonoId" required noStyle>
                                    <SelectItem
                                      disabled
                                      noDisabledBackground
                                      placeholder="Cuenta Abono"
                                      width="80%"
                                    >
                                      {this.state.objetoCuentaContable}
                                    </SelectItem>
                                  </FormItem>
                                  <ButtonItem
                                    icon={<PlusOutlined />}
                                    style={{ width: "14%" }}
                                    disabled
                                  />
                                </Input.Group>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                  {this.props.lotesCaducidades && (
                    <Row>
                      <Col span={12}>
                        <FormItem
                          label="Lotes"
                          name="conLotesYCaducidades"
                          margin
                          valuePropName="checked"
                          tooltip="Si los insumos que agregaras tienen lotes o caducidades, activa esta opción para poder agregarlos por fila"
                          labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}
                        >
                          <SwitchItem disabled />
                        </FormItem>
                      </Col>
                    </Row>
                  )}
                </DynamicCardForm>
              </Col>
              </Row>
              <div style={{ marginTop: 40 }}>
                <TabbedDynamicTable
                  formInstance={this.formRef}
                  defaultActiveKey="insumos"
                  isMobile={isMobile}
                  tabs={allTabs}
                />
              </div>
            </Form>
          </Spin>
        </div>
         <ModalOrdenAgregarInventarioPdf
          visible={this.state.modalPdfVisible}
          onCancel={this.toggleModalPdf}
          ordenId={this.props.location.state.id}
          ordenNumero={this.state.numOrden}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    lotesCaducidades: state.empresa.lotesCaducidades,
    moduloWms: state.empresa.moduloWms,
  };
};

export default connect(mapStateToProps)(VerOrdenAgregarInventario);
